module.exports = __webpack_public_path__ + "assets/8cf847b20b90cbe45df4acbd17db7e0f.mp3";